import React from "react"
import { track } from "../../utils/analytics"
import "./whatsAppFloat.scss"

// Pulpit's WhatsApp line: +91 80520 80501  ->  wa.me needs country code, no "+".
const WA_NUMBER = "918052080501"
const WA_TEXT = "Hi Pulpit, I'd like to book a cab."
const WA_LINK = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(WA_TEXT)}`

// WhatsApp glyph (single path), sized by the SVG width/height.
const WhatsAppGlyph = () => (
  <svg viewBox="0 0 24 24" width="32" height="32" fill="currentColor" aria-hidden="true" focusable="false">
    <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38c1.45.79 3.08 1.21 4.79 1.21h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.816 9.816 0 0012.04 2zm0 1.67c2.2 0 4.26.86 5.82 2.42a8.18 8.18 0 012.41 5.82c0 4.54-3.7 8.23-8.24 8.23-1.48 0-2.93-.4-4.19-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.18 8.18 0 01-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24zM8.53 7.33c-.16 0-.43.06-.66.31-.22.25-.86.85-.86 2.07 0 1.22.89 2.4 1.01 2.56.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.46-.6 1.67-1.18.21-.58.21-1.07.14-1.18-.06-.1-.22-.16-.47-.28-.25-.12-1.47-.72-1.69-.8-.23-.09-.39-.13-.56.12-.16.25-.64.79-.78.95-.14.17-.29.19-.54.06-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.43.12-.14.16-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.35-.76-1.85-.2-.48-.4-.42-.56-.43h-.48z" />
  </svg>
)

/**
 * Floating WhatsApp chat button, global on every page. Opens a chat with the
 * Pulpit line and pushes a `whatsapp_click` event so GTM/GA4 can attribute it.
 * Sits bottom-right; the Zoho chat lives bottom-left, so they don't collide.
 */
const WhatsAppFloat = () => {
  const onClick = () => {
    try { track("whatsapp_click", { location: "float_button" }) } catch (e) { /* never block the click */ }
  }
  return (
    <a
      href={WA_LINK}
      target="_blank"
      rel="noopener noreferrer"
      className="wa-float"
      aria-label="Chat with Pulpit on WhatsApp"
      onClick={onClick}
    >
      <span className="wa-float__label">Chat with us on WhatsApp</span>
      <span className="wa-float__glyph"><WhatsAppGlyph /></span>
    </a>
  )
}

export default WhatsAppFloat
